<template>
<!-- 甲方数据报表 -->
  <div id="CustomerOwnerDataEcharts">
    <div class="lineChart">
        <div id="engineeringNum" ref="engineeringNum"></div>
    </div>
    <div class="BottomBox">
      <div class="Onehistogram" ref="Onehistogram"></div>
      <div class="TwohistogramBox">
        <div id="Twohistogram" ref="Twohistogram"></div>
        <span class="showTips" v-if="showTips" :style="{left: x + 'px', top: y + 'px'}">{{tipsName}}</span>
        <div class="nodata_box" v-show="IndustryData.series && !IndustryData.series[0].data.length">
            <img src="https://xmyun.zhoty.com/xmerp/pcadmin/static/images/report_item_nodata.png" alt="">
            <span>暂无数据</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {EchartsformatDate,checkDay} from '@/helper/VueHelper.js'
export default {
  props:['CustomerDataList','natureData','IndustryData','dataRange'],
data() {
  return {
      screenWidth: document.body.clientWidth, // 屏幕宽度
      natureDataList:[],
      IndustryDataList:[],
      Juage:'',
      x: 0,
      y: 0,
      showTips: false,
      tipsName: ''
  };
},
methods:{
  initChart1() {
      let chart1 = this.$echarts.getInstanceByDom(this.$refs.engineeringNum);
      if (chart1 == null) {
        this.myChart1 = this.$echarts.init(this.$refs.engineeringNum);
      }
      let option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: "客户数量",
          top:'24',  
          left:this.$route.query.identification ? '20' : '30',      
          textStyle:{
              fontWeight:500,
          }     
        },
        xAxis: [
            {
                type: "category",
                boundaryGap: false,
                data: this.CustomerDataList.xAxis.data,
                axisLabel: {
                 align:'center',
                 padding:[10,0,0,0],
                 show:this.$route.query.identification ? false : true ,
                 interval:this.screenWidth >= 1366 || checkDay(this.dataRange) ? 'auto' : Math.ceil( this.CustomerDataList.xAxis.data.length / 10),
                 color:'#666666'                
                },
                axisTick: {
                  show: false,
                },
                splitLine: {
                  show:  Math.max(...this.CustomerDataList.series[0].data) == 0 ? false : true,
                  lineStyle: {
                    color: '#DDDDDD',
                  },
                },
                axisLine: {
                    //坐标轴轴线相关设置。数学上的x轴
                    show: Math.max(...this.CustomerDataList.series[0].data) == 0 ? true : false,
                    lineStyle: {
                        color: '#DDDDDD',
                    },
                },                                                               
            }
        ],
        yAxis: [
        {
          type: "value", 
          name:'数量(个)',
          minInterval:1, // 个数显示一个,无小数点
          show:Math.max(...this.CustomerDataList.series[0].data) == 0 ? false : true,
          axisLabel: { 
            color:'#666666'
          },
          axisTick: false,
          splitLine: {
            show: Math.max(...this.CustomerDataList.series[0].data) == 0 ? false : true,
            lineStyle: {
              color: '#DDDDDD',
              type:'solid'
            },
          },  
          axisLine: {
              //坐标轴轴线相关设置
              show: true,
              lineStyle: {
                  color: '#DDDDDD',
              },
          }, 
          nameTextStyle:{
            padding:[0,10,0,0],
            color:'#666666'
          }               
        }         
        ],
        tooltip: {
          trigger: "axis",  
          axisPointer: {
              lineStyle: {
                  color: '#DDDDDD',
                  type:'solid'
              },
          },
          formatter: function (params) {
              const str = `<div style="margin:3px 9px;" >${EchartsformatDate(params[0].axisValue)}</div>
                     <div style="margin:3px 10px;">
                      <div>客户数量：${params[0].data}个</div>
                     </div>`;
              return str;
           }                           
        },
        series: [
          {
            data: this.CustomerDataList.series[0].data ,
            type: "line",
            smooth: true,
            showSymbol: false,
            symbolSize: 5,   //设定实心点的大小
            lineStyle:{
                normal:{
                    color:'#6ac1ff',
                    opacity:Math.max(...this.CustomerDataList.series[0].data) == 0 ? false : true,
                }
            }, 
            itemStyle: {
                normal:{
                    color: '#6ea6ff',
                    opacity:Math.max(...this.CustomerDataList.series[0].data) == 0 ? false : true,
                }
            },          
            areaStyle: {
                normal: {
                    //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                    color: '#e6f5ff'
                },                
            },
          },
        ],
        grid: {
          top: this.$route.query.identification ? '100' : "100",
          left: this.$route.query.identification ? '54' : (this.screenWidth <=1366 ? '65' : '65'),
          right:this.$route.query.identification ? '48' :  "50",
          bottom: this.$route.query.identification ? '25' : "60",
        },
      };
      this.myChart1.setOption(option);
      window.addEventListener("resize", () => {
        if(this.$route.query.identification) {
          var resize = {
            width: this.screenWidth - 21,
          };
          this.myChart1.resize(resize)
        } else {
          this.myChart1.resize()
        }
      })         
  }, 
  initChart2(){
    let {series} = this.natureData
      let chart2 = this.$echarts.getInstanceByDom(this.$refs.Onehistogram);
      if (chart2 == null) {
        this.myChart2 = this.$echarts.init(this.$refs.Onehistogram);
      }
      let option = {
              textStyle: {
                fontFamily: 'PingFang-M'
              },
              title: {
                text: '按性质',
                top:'24',  
                left:this.$route.query.identification ? '20' : '30',      
                textStyle:{
                    fontWeight:500,
                } 
              },
              tooltip: {
                trigger: 'axis',
                axisPointer: {
                  type: 'none'
                },
              formatter: function (params) {
                  const str = `<div style="margin:3px 10px;">占比：${params[0].value}%</div>
                               <div style="margin:3px 10px;">个数：${series[0].data[params[0].dataIndex]}个</div>`
                  return str
                }  
              },
              grid: {
                left:this.$route.query.identification ? '2' : '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
              },
              xAxis: [
                {
                position: 'top',  
                type: 'value',
                boundaryGap: [0, 0.01],
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: '#DDDDDD',
                    type:'dashed'
                  },
                }, 
                axisTick:false, // 刻度
                axisLine:{
                    show:false // 轴  
                  },
                axisLabel: {
                  formatter:'{value}%',
                  color:'#666666',
                  padding:this.$route.query.identification ?  [0,10,0,0] :  [0,0,0,0]
                }
              }
              ],
              yAxis: [
                {
                  type: 'category',
                  inverse:true,
                  axisLabel: {
                    formatter: (val,index)=>{
                      let res =  '';
                     this.natureDataList.forEach((item,i)=>{
                        if( i == index) {
                          res = item
                        }
                      })
                      return val + `(${res}个)`
                    },
                    textStyle:{
                      color:'#666666'
                    }
                  },                  
                  data: this.natureData.yAxis.data,
                  splitLine: {
                    show: true,
                    lineStyle: {
                      color: '#DDDDDD',
                      type:'dashed'
                    },
                  },
                  axisTick:false, // 刻度
                  axisLine:{
                    show:false // 轴 
                  }                  
                }           
              ],
              series: [
                {
                  type: 'bar',
                  data: this.natureData.series[0].percent,
                  barWidth : 20,
                  itemStyle:{
                     normal:{
                       color:'#57b9ff',
                       label:{
                        show:true,
                        position:this.$route.query.identification ? ['0%','25%'] : 'right',
                        textStyle:{
                          color:'#666666'
                        },
                        formatter:(value,index)=>{
                          return value.value + '%'
                        }
                       }
                    } 
                  },
                },
              ]
            };
        this.myChart2.setOption(option);
        window.addEventListener("resize", () => {
          if(this.$route.query.identification) {
            var resize = {
              width: this.screenWidth - 21,
            };
            this.myChart2.resize(resize)
          } else {
            this.myChart2.resize()
          }
        })         
  },
  initChart3(){
    let {series} = this.IndustryData
      let chart3 = this.$echarts.getInstanceByDom(this.$refs.Twohistogram);
      if (chart3 == null) {
        this.myChart3 = this.$echarts.init(this.$refs.Twohistogram);
      }
      let option = {
              textStyle: {
                fontFamily: 'PingFang-M'
              },
              title: {
                show:series[0].data.length ? true : true,
                text: '按行业',
                top:'24',  
                left:this.$route.query.identification ? '20' : '30',      
                textStyle:{
                    fontWeight:500,
                }
              },
              tooltip: {
                trigger: 'axis',
                axisPointer: {
                  type: 'none'
                },
              formatter: function (params) {
                  const str = `<div style="margin:3px 10px;">占比：${params[0].data}%</div>
                               <div style="margin:3px 10px;">个数：${series[0].data[params[0].dataIndex]}个</div>`
                  return str
                }                  
              },
              legend: {},                                              
              grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
              },
              xAxis: [
                {
                position: 'top',
                type: 'value',
                boundaryGap: [0, 0.01],
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: '#dddddd',
                    type:'dashed'
                  },
                }, 
                axisTick:false, // 刻度
                axisLine:{
                    show:false // 轴  
                },
                axisLabel: {
                  formatter:'{value}%',
                  color:'#666666',
                  padding:this.$route.query.identification ?  [0,10,0,0] :  [0,0,0,0]
                }  
                }
              ],
              yAxis: [
                {
                  type: 'category',
                  inverse:true, // Y轴数据颠倒
                  axisLabel: {
                    formatter: (val,index)=>{
                      let res = ''
                      this.IndustryDataList.forEach((item,i)=>{
                        if(i == index){
                          res = item
                        }
                      })
                      if(this.$route.query.identification == 'pplet' || this.screenWidth <= 1366){
                        let params = ''
                        if(val.length > 5){
                          params = val.substr(0,5) + '...';
                          return params  +  `(${res}个)`
                        }else{
                          return val + `(${res}个)`
                        }
                      }else{
                          return val + `(${res}个)`
                      }
                    },
                    textStyle:{
                      color:'#666666'
                    }
                  },                  
                  data: this.IndustryData.yAxis.data,
                  triggerEvent: true,
                  splitLine: {
                    show: true,
                    lineStyle: {
                      color: '#dddddd',
                      type:'dashed'
                    },
                  },
                  axisTick:false, // 刻度
                  axisLine:{
                    show:false // 轴 
                  }                  
                }                 
              ],
              series: [
                {
                  name: '2011',
                  type: 'bar',
                  data: this.IndustryData.series[0].percent,
                  barWidth : 20,
                  itemStyle:{ 
                    normal:{
                       color:'#ffb96e',
                       label:{
                        show:true,
                        position:this.$route.query.identification ? ['0%','25%'] :'right',
                        textStyle:{
                          color:'#666666'
                        },
                        formatter:(value)=>{
                          return value.value + '%'
                        }
                       }                       
                    } 
                  }
                },
              ]
            };
        this.myChart3.setOption(option);
        window.addEventListener("resize", () => {
          if(this.$route.query.identification) {
            var resize = {
              width: this.screenWidth - 21,
            };
            this.myChart3.resize(resize)
          } else {
            this.myChart3.resize()
          }
        })   
        this.myChart3.on('mouseover', (params) => {
          if(params.componentType =="yAxis"){ 
              // console.log(params.event)
              // console.log(params.event.target.style.text.length)
              // console.log(params.event.target.style.text.length > 5)
              // console.log(params.event.offsetX,params.event.offsetY,params.event.target.style.text)
              if(params.event.target.eventData.value.length > 5 && this.screenWidth <=1366){
              this.showTips = true;
              this.x = params.event.offsetX + 20;
              this.y = params.event.offsetY;
              this.tipsName = params.event.target.eventData.value;
              }
          }else{ 
              this.showTips = false;
          } 
      });
      this.myChart3.on('mouseout', (params) => {
        this.showTips = false;
      })
  }    
},
mounted(){
  let _this = this;  
  window.onresize = () => {
    return (() => {
    window.screenWidth = document.body.clientWidth; //实时宽度
    _this.screenWidth = window.screenWidth;
   })();
  };
},
watch:{
 // 头部数据
 CustomerDataList(val){  
    this.$nextTick(function () {
      var myEvent = new Event('resize'); // 创建一个支持冒泡且不能被取消的resize事件
      window.dispatchEvent(myEvent); // 事件可以在任何元素触发
    }) 
    this.initChart1();
 },
// 性质
 natureData(){
    this.natureDataList = this.natureData.series[0].data
    this.$nextTick(function () {
      var myEvent = new Event('resize'); // 创建一个支持冒泡且不能被取消的resize事件
      window.dispatchEvent(myEvent); // 事件可以在任何元素触发
    })     
    this.initChart2();
 },
 // 行业
 IndustryData(val){
    this.IndustryDataList = this.IndustryData.series[0].data
    this.$nextTick(function () {
      var myEvent = new Event('resize'); // 创建一个支持冒泡且不能被取消的resize事件
      window.dispatchEvent(myEvent); // 事件可以在任何元素触发
    }) 
    this.initChart3();  
 }
}
}
</script>

<style lang="scss" scoped>
#CustomerOwnerDataEcharts{
    .lineChart{
        width: 100%;
        height: 5.2rem;
        margin-top: 0.24rem;
        background-color: #fff;
        -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
         box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
         border-radius:0.1rem;
        //  padding: 0.24rem 0 0.3rem 0.54rem;
        #engineeringNum{
         width: 100%;
         height: 5.2rem; 
        }
    }
    .BottomBox{
      display: flex;
      margin-top: 0.24rem;
      .Onehistogram{
        background-color: #fff;
        -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
         box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
         border-radius:0.1rem;        
        width: 50%;
        height: 4.5rem;
        margin-right: 0.12rem;
      }
      .TwohistogramBox{
        position: relative;
        background-color: #fff;
        -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
         box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
         border-radius:0.1rem;        
        width: 50%;
        height: 4.5rem;
        margin-left: 0.12rem;
        .showTips {
          position: absolute;
          // left: 190px;
          // top: 200px;
          padding: 6px 12px;
          background: rgba(0, 0, 0, 0.5);
          color: #fff;
          border-radius: 4px;
        }
        #Twohistogram{
          width: 100%;
          height:100%;
        }
      .nodata_box{
        position: absolute;
        top: 8%;
        left: 48%;
        height: calc(100% - 48px);
        display: flex;
        flex-direction: column;;
        justify-content: center;
        align-items: center;
        span{
          font-size: 16px;
          color: #ccc;
          line-height: 44px;
        }
      }        
      }      
    }
}
@media screen and (max-width: 768px) {
  #CustomerOwnerDataEcharts{
    box-sizing: border-box;
    padding: 0 0.12rem;
    .lineChart{
      margin-top: 0.14rem;
      border: none;
    }
    .BottomBox{
        flex-direction: column;
        margin-top: 0.14rem;
        .Onehistogram{
          background-color: #fff !important;
          width: 100%;
          border: none;
          margin: 0;
        }
        .TwohistogramBox{
          background-color: #fff !important;
          width: 100%;
          border: none;
          margin-left:0;        
          // margin: 0.1rem 0;
          margin-top: 0.14rem;
          .nodata_box{
            left: 41%;
          }
          #Twohistogram{
            width: 100%;
          }
        }
    }
  }
}
</style>


// WEBPACK FOOTER //
// CustomerOwnerDataEcharts.vue?4593b9be